import { useFeatureFlags } from '@/helpers/useFeatureFlags';

/**
 * Route guard for the customer (D2C) ERHL journey. Unlike the broker ERHL guard there is no
 * broker session to resolve: the journey opens only when both the `erhl-product` and
 * `erhl-d2c-submission` flags are on, and otherwise sends the visitor to the landing page.
 */
export const erhlCustomerGuard = async () => {
  const { initialize, isErhlD2cEnabled } = useFeatureFlags();
  await initialize();
  if (!isErhlD2cEnabled()) {
    return { name: 'home' };
  }
  return true;
};
